"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DetailsCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CollapsibleList = _interopRequireDefault(require("./CollapsibleList"));
var _r10SourceLibrary = require("r10-source-library");
var _Title = _interopRequireDefault(require("./blocks/details/Title"));
var _OfferDescription = _interopRequireDefault(require("./blocks/details/OfferDescription"));
var _LineWithOfferExpireDate = _interopRequireDefault(require("./blocks/details/LineWithOfferExpireDate"));
var _DividerBottomSpace = _interopRequireDefault(require("./blocks/DividerBottomSpace"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _jsonpathPlus = require("jsonpath-plus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DetailsCard(_ref) {
  var title = _ref.title,
    campaignDetails = _ref.campaignDetails;
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$jsonPaths = _useConfig.jsonPaths,
    _useConfig$jsonPaths2 = _useConfig$jsonPaths === void 0 ? {} : _useConfig$jsonPaths,
    subtitlePath = _useConfig$jsonPaths2.subtitlePath,
    longDescriptionPath = _useConfig$jsonPaths2.longDescriptionPath,
    endDateTimePath = _useConfig$jsonPaths2.endDateTimePath,
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    listItemsLimit = _useConfig$widgetCust2.listItemsLimit,
    detailsSeparator = _useConfig$widgetCust2.detailsSeparator;
  var _JSONPath = (0, _jsonpathPlus.JSONPath)({
      path: subtitlePath,
      json: campaignDetails[0]
    }),
    _JSONPath2 = _slicedToArray(_JSONPath, 1),
    subtitle = _JSONPath2[0];
  var _JSONPath3 = (0, _jsonpathPlus.JSONPath)({
      path: longDescriptionPath,
      json: campaignDetails[0]
    }),
    _JSONPath4 = _slicedToArray(_JSONPath3, 1),
    longDescription = _JSONPath4[0];
  var _JSONPath5 = (0, _jsonpathPlus.JSONPath)({
      path: endDateTimePath,
      json: campaignDetails[0]
    }),
    _JSONPath6 = _slicedToArray(_JSONPath5, 1),
    endDateTime = _JSONPath6[0];
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true,
    dataAttributes: {
      'data-testid': 'pega-details-card'
    }
  }, title && /*#__PURE__*/_react.default.createElement(_Title.default, {
    title: title
  }), subtitle && /*#__PURE__*/_react.default.createElement(_OfferDescription.default, {
    subtitle: subtitle
  }), endDateTime && /*#__PURE__*/_react.default.createElement(_LineWithOfferExpireDate.default, {
    endDateTime: endDateTime
  }), /*#__PURE__*/_react.default.createElement(_DividerBottomSpace.default, {
    space: 3
  }), longDescription && /*#__PURE__*/_react.default.createElement(_CollapsibleList.default, {
    data: longDescription.split(detailsSeparator),
    limit: listItemsLimit
  }));
}
DetailsCard.propTypes = {
  title: _propTypes.default.string,
  campaignDetails: _propTypes.default.any
};